import { UseFormRegister } from 'react-hook-form';

import { AddressVariables } from 'enums/AddressVariables';

import { getMessageForInvalidFields, getMessageForRequiredFields, getPatterns } from './validationUtils';

export const addressRegistration = (
  register: UseFormRegister<any>,
  inputNames?: {
    streetName?: string;
    cityName?: string;
    stateName?: string;
    zipName?: string;
    copyFrom?: string;
    countyName?: string;
  },
  inputLabels?: {
    streetLabel?: string;
    cityLabel?: string;
    stateLabel?: string;
    zipLabel?: string;
    countyLabel?: string;
  },
  required: boolean = true,
) => {
  const names = [
    {
      name: inputNames?.streetName || 'street_address',
      label: inputLabels?.streetLabel || 'Street Address',
    },
    {
      name: inputNames?.cityName || 'city',
      label: inputLabels?.cityLabel || 'City',
    },
    {
      name: inputNames?.stateName || 'state',
      label: inputLabels?.stateLabel || 'State',
    },
    {
      name: inputNames?.zipName || 'zip',
      label: inputLabels?.zipLabel || 'Zip Code',
    },
  ];

  if (inputNames?.copyFrom) {
    names.push({
      name: inputNames.copyFrom,
      label: '',
    });
  }

  if (inputNames?.countyName) {
    names.push({
      name: inputNames.countyName,
      label: '',
    });
  }

  names.forEach((item) => {
    const isCounty = item.name === AddressVariables.BorrowerCounty;
    const isCheckbox = item.name === AddressVariables.CoborrowerPreviousAddress1SameAsBorrower;

    register(item.name, {
      required: {
        value: isCheckbox || isCounty ? false : required,
        message: getMessageForRequiredFields(item.label),
      },
      pattern: item.name.includes('zip')
        ? {
            value: getPatterns().zip,
            message: getMessageForInvalidFields(item.label),
          }
        : undefined,
    });
  });
};

interface RegisterFieldProps {
  name: string;
  required?: boolean;
  label?: string;
  requiredErrorMessage?: string;
  pattern?: RegExp;
  customValidation?: (value: string) => boolean | string;
  validationErrorMessage?: string;
}

export const registerFields = (register: UseFormRegister<any>, fieldsForRegistration: RegisterFieldProps[]) => {
  fieldsForRegistration.forEach(
    ({ name, required, label, pattern, customValidation, validationErrorMessage, requiredErrorMessage }) => {
      register(name, {
        required: {
          value: !!required,
          message: requiredErrorMessage || getMessageForRequiredFields(label),
        },
        pattern: pattern
          ? {
              value: pattern,
              message: validationErrorMessage || getMessageForInvalidFields(label),
            }
          : undefined,
        validate:
          !!required && customValidation
            ? (value: string) => customValidation(value) || validationErrorMessage
            : undefined,
      });
    },
  );
};
